import { Box, Stack } from "@mui/material";

const SELECT_ALL_MIN_WIDTH = "5.5rem";

/**
 * The search field with the select-all button: beside the field and against the right edge from `sm` up
 * (the field takes the rest of the row), below it and on the left on phones.
 * The cut is the window's breakpoint, not the dialog's width: the prescription picker is ~444 px
 * wide on desktop and a large phone is ~430 px, so the dialog's width can't tell them apart.
 * The button slot keeps the width of its widest state ("Todas" with the over-limit icon), so toggling
 * it never resizes the field.
 */
const SearchRow = ({ search, selectAll }) => (
  <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} columnGap={1} rowGap={1}>
    <Box sx={{ flex: { sm: "1 1 0" }, minWidth: 0 }}>{search}</Box>
    <Box sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-end" }, flex: { sm: "0 0 auto" }, minWidth: { sm: SELECT_ALL_MIN_WIDTH } }}>
      {selectAll}
    </Box>
  </Stack>
);

export default SearchRow;
